import { ActionType, ConsoleAction, datetime } from '@bringg/types';

import type WorkflowStore from './workflow-store';
import { Workflow } from '../utils/types';

class UnreadableWorkflow {
	readonly isUnreadable = true;
	readonly id: number;
	readonly title: string;
	readonly enabled: boolean;
	readonly team_ids: number[] | undefined;
	readonly created_at: datetime;
	readonly updated_at: datetime;
	readonly updated_by_user_id: number;
	readonly alertActions: ConsoleAction[];
	readonly original: Workflow;

	constructor(item: Workflow) {
		const workflow: Partial<Workflow> = typeof item === 'object' && item !== null ? item : {};

		this.original = item;
		this.id = workflow.id;
		this.title = workflow.title;
		this.enabled = workflow.enabled;
		this.team_ids = workflow.team_ids;
		this.created_at = workflow.created_at;
		this.updated_at = workflow.updated_at;
		this.updated_by_user_id = workflow.updated_by_user_id;
		this.alertActions = Array.isArray(workflow.actions)
			? (workflow.actions.filter(
					action =>
						action?.action_type === ActionType.ALERT &&
						typeof action.data === 'object' &&
						action.data !== null
			  ) as ConsoleAction[])
			: [];
	}

	dispose() {
		// Nothing to release: a placeholder has no reactions.
	}

	isViewSupported() {
		return false;
	}
}

export type WorkflowRepoItem = WorkflowStore | UnreadableWorkflow;

export function isUnreadableWorkflow(workflow: object | undefined | null): workflow is UnreadableWorkflow {
	return (workflow as UnreadableWorkflow)?.isUnreadable === true;
}

export default UnreadableWorkflow;
